import axios from "@axios";

const OPERATIONAL_FORM_TEMPLATE_LIST_PARAMS = {
  q: "",
  max: 500,
  "page[n]": 1,
  sortBy: "name",
  sortDesc: false,
};

export async function fetchOperationalFormTemplateOptions() {
  const { data } = await axios.get("/v1/operational-security-forms/templates", {
    params: OPERATIONAL_FORM_TEMPLATE_LIST_PARAMS,
  });
  const list = data && data.data ? data.data : [];
  const byId = new Map();
  list.forEach((item) => {
    if (item.id != null && !byId.has(item.id)) {
      byId.set(item.id, {
        value: item.id,
        label: item.name || String(item.id),
      });
    }
  });
  return Array.from(byId.values());
}
